import api from "../../api";
/* eslint-disable */
export default {
  namespaced: true,
  state: {
    ScheduledRunSchedules: [],
   
  },
  getters: {
    getScheduledRunSchedules(state) {
      return state.ScheduledRunSchedules;
    }
  },
  mutations: {
    SetScheduledRunSchedules(state, data) {
      state.ScheduledRunSchedules = [];
      state.ScheduledRunSchedules = data;
    }
  },
  actions: {
    getScheduledRunSchedules({ commit }) {
      return new Promise((resolve, rej) => {
      api()
        .post(
          `scheduledRunSchedules/getScheduledRunSchedules`,
          {},
          {
            headers: {
              Authorization: localStorage.getItem("JwtToken"),
            },
          }
        )
        .then((res) => {
          resolve(res);
          commit("SetScheduledRunSchedules", res.data);
        })
        .catch((err) => console.log(err));});
    },   
   
  },
};
